// Thẻ thống kê nhanh ở đầu trang: tổng / chờ duyệt / chưa trả lời / đang hiển thị
import React from "react";
import { Card, Statistic } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments, faClock, faEye, faHourglassHalf } from "@fortawesome/free-solid-svg-icons";

const items = [
    { key: "total", title: "Tổng bình luận", icon: faComments, color: "#3b82f6" },
    { key: "pending", title: "Chờ duyệt", icon: faHourglassHalf, color: "#ef4444" },
    { key: "unanswered", title: "Chưa admin trả lời", icon: faClock, color: "#f59e0b" },
    { key: "shown", title: "Đang hiển thị", icon: faEye, color: "#10b981" },
];

export default function CommentStats({ total, pendingTotal, unansweredTotal, shown }) {
    const values = { total, pending: pendingTotal, unanswered: unansweredTotal, shown };
    return (
        // 2 cột trên mobile để 4 thẻ không chiếm cả màn hình
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
            {items.map((it) => (
                <Card key={it.key} size="small" styles={{ body: { padding: 16 } }}>
                    <Statistic
                        title={
                            <span className="flex items-center gap-2 text-content-3">
                                <FontAwesomeIcon icon={it.icon} style={{ color: it.color }} />
                                {it.title}
                            </span>
                        }
                        value={values[it.key] || 0}
                        valueStyle={{ color: it.color, fontWeight: 600 }}
                    />
                </Card>
            ))}
        </div>
    );
}
